import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
// import XHR from "i18next-xhr-backend";

i18n
  .use(Backend)
  .use(LanguageDetector)
  // .use(XHR)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem("i18nextLng") || "en",
    // fallbackLng: "en",
    debug: true,
    detection: {
      order: ["queryString", "cookie"],
      cache: ["cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
    // backend: {
    //   loadPath:
    //     "https://emadsamy.github.io/double-kick-build/locales/{{lng}}/{{ns}}.json",
    //   crossDomain: true,
    // },
  });

export default i18n;
